/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import { useTableColumn } from 'xrk-components';
import { date, fen2yuan, maskAllMethod } from '@/utils/formatter';
import {
  ORDER_PRICE_TYPE,
  PAY_TYPE,
  ORDER_PAY_STATUS,
  TERMINAL_TYPE,
  ORDER_PAY_STATUS_PAY_SUCCESS
} from '../constants';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { taxPatternMapping } from '@constants/project';
import router from '@/router';

/** 序号 */
export const indexCol = useTableColumn({
  type: 'index',
  label: '序号'
});

/** 订单编号 */
export const orderNoCol = useTableColumn({
  label: '订单编号',
  prop: 'orderNo',
  width: 210
});

/** 经营者 */
export const operatorCol = useTableColumn({
  label: '经营者',
  prop: 'operator'
});

/** 个体工商户名称 */
export const individualNameCol = useTableColumn({
  label: '个体工商户名称',
  prop: 'individualName'
});

/** 所属园区 */
export const parkNameCol = useTableColumn({
  label: '所属园区',
  prop: 'belongingPark'
});

/** 终端服务人员 */
export const fullNameCol = useTableColumn({
  label: '终端服务人员',
  prop: 'userName',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'name', val: cellValue })
});

/** 手机号 */
export const phoneCol = useTableColumn({
  label: '手机号',
  prop: 'phone',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'phone', val: cellValue })
});

/** 结算任务量（条） */
export const settlementTaskCountCol = useTableColumn({
  label: '结算任务量（条）',
  prop: 'finishSum'
});

/** 终端结算单价（元） */
export const taskPriceCol = useTableColumn({
  label: '终端结算单价（元）',
  prop: 'terminalSettlementPrice',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 终端结算金额（元） */
export const projectPayPriceCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 结算单号 */
export const industryFenpeiCodeCol = useTableColumn({
  label: '结算单号',
  prop: 'settlementCode'
});

/** 项目名称 */
export const projectNameCol = useTableColumn({
  label: '项目名称',
  prop: 'projectName',
  minWidth: 300
});

/** 项目编码 */
export const projectNoCol = useTableColumn({
  label: '项目编码',
  prop: 'projectCode',
  minWidth: 150
});

/** 交易结构 */
export const taxCollectionPatternCol = useTableColumn({
  label: '交易结构',
  prop: 'taxPattern',
  formatter({ cellValue }) {
    return taxPatternMapping[cellValue]?.label;
  }
});

/** 终端类型 */
export const terminalTypeCol = useTableColumn({
  label: '终端类型',
  prop: 'terminalType',
  formatter({ cellValue }) {
    return TERMINAL_TYPE[cellValue]?.label;
  }
});

/** 工业名称 */
export const entpNameCol = useTableColumn({
  label: '工业名称',
  prop: 'industryName',
  minWidth: 300
});

/** 供应商名称 */
export const supplierNameCol = useTableColumn({
  label: '供应商名称',
  prop: 'supplierName',
  minWidth: 300
});

/** 订单生成时间 */
export const orderTimeCol = useTableColumn({
  label: '订单生成时间',
  prop: 'orderTime',
  minWidth: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单完结时间 */
export const orderFinishTimeCol = useTableColumn({
  label: '订单完结时间',
  prop: 'orderFinishTime',
  minWidth: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 终端到账时间 */
export const endPointFinishPayAtCol = useTableColumn({
  label: '终端到账时间',
  prop: 'terminalAccountTime',
  minWidth: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单类型 */
export const orderTypeCol = useTableColumn({
  label: '订单类型',
  prop: 'orderType',
  formatter({ cellValue }) {
    return ORDER_PRICE_TYPE[cellValue]?.label;
  }
});
/** 支付方式 */
export const payTypeCol = useTableColumn({
  label: '支付方式',
  prop: 'payType',
  formatter({ cellValue }) {
    return PAY_TYPE[cellValue]?.label;
  }
});

/** 支付通道 */
export const payPassagewayCol = useTableColumn({
  label: '支付通道',
  prop: 'payPassagewayCode',
  formatter({ cellValue }) {
    return PAY_PASSAGEWAY_MAPPING?.[cellValue]?.label || '-';
  }
});

/** 订单支付金额（元） */
export const orderPriceCol = useTableColumn({
  label: '订单支付金额（元）',
  prop: 'orderPaymentAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 预计扣除个税金额（元） */
export const yjkcPriceCol = useTableColumn({
  label: '预计扣除个税金额（元）',
  prop: 'deductIndividualTaxAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 预计订单支付金额（元） */
export const yjzfPriceCol = useTableColumn({
  label: '预计订单支付金额（元）',
  prop: 'paidOrderAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 扣除个税金额（元） */
export const deductIndividualTaxAmountCol = useTableColumn({
  label: '扣除个税金额（元）',
  prop: 'deductIndividualTaxAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});
/**
 * 应付订单金额（元）
 */
export const payAmountCol = useTableColumn({
  label: '应付订单金额（元）',
  prop: 'payableOrderAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue),
  minWidth: 160
});

/** 实付订单金额（元） */
export const paidOrderAmountCol = useTableColumn({
  label: '实付订单金额（元）',
  prop: 'paidOrderAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 供应商服务费率（%） */
export const gysSumScaleCol = useTableColumn({
  label: '供应商服务费率（%）',
  prop: 'supplierServiceRate',
  formatter: ({ cellValue }) => fen2yuan(+cellValue)
});

/** 支付状态 */
export const payStatusCol = useTableColumn({
  label: '支付状态',
  prop: 'payStatus',
  formatter({ cellValue }) {
    return ORDER_PAY_STATUS?.[cellValue]?.label || '-';
  }
});

/** 供应商支付状态 */
export const supplierPayStatusCol = useTableColumn({
  label: '供应商支付状态',
  prop: 'supplierPayStatus',
  formatter({ cellValue }) {
    return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
  }
});

/** 支付对象 */
export const payTargetCol = useTableColumn({
  label: '支付对象',
  prop: 'paymentRecipient'
});

/** 项目结算金额（元/含税） */
export const projectSettlementScalePriceCol = useTableColumn({
  label: '项目结算金额（元/含税）',
  prop: 'projectSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 增值税率（%） */
export const vatRateCol = useTableColumn({
  label: '增值税率（%）',
  prop: 'incrementTaxRate',
  formatter: ({ cellValue }) => fen2yuan(+cellValue)
});

/** 平台/商务服务费率（%） */
export const commissionCol = (type: number) => {
  const label = type === 1 ? '平台服务费率（%）' : '商务服务费率（%）';
  return useTableColumn({
    label,
    prop: 'feeTaxRate',
    formatter: ({ cellValue }) => fen2yuan(+cellValue)
  });
};

/** 平台/商务服务费金额（元） */
export const platformServicesPriceCol = (type: number) => {
  const label = type === 1 ? '平台服务费金额（元）' : '商务服务费金额（元）';
  return useTableColumn({
    label,
    prop: 'serviceFeeAmount',
    formatter: ({ cellValue }) => fen2yuan(cellValue)
  });
};

/** 终端结算金额（元） */
export const csoPriceSumCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});
/**
 * 服务费列表
 * @param entry 1-1-1 => 服务费类型-工业上下线-交易结构
 */
export const getServiceCol = entry => {
  const getTaxType = () => {
    // 获取订单来自劳务还是经营taxType 1:经营 2:劳务
    return { taxType: router.currentRoute.value.meta.taxType };
  };
  const columnsMap = {
    // 平台服务费-工业上线-汇总申报
    '2-1-1': {
      tips: '平台服务费金额  =  项目结算金额【含税】 * （1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业上线-委托代发
    '2-1-3': {
      tips: '平台服务费金额  =  项目结算金额【含税】 * （1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业不上线-汇总申报
    '2-0-1': {
      tips: '平台服务费金额 = 终端结算金额 * （1+供应商服务费率）*（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        gysSumScaleCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业不上线-委托代发
    '2-0-3': {
      tips: '平台服务费金额 = 终端结算金额 * （1+供应商服务费率）*（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        gysSumScaleCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业上线-运营基地
    '2-1-4': {
      tips: '平台服务费金额 = 项目结算金额【含税】 * （1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业不上线-运营基地
    '2-0-4': {
      tips: '平台服务费金额 = 终端结算金额 *（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业上线-委托代开
    '2-1-6': {
      tips: '平台服务费金额 = 终端结算金额 *（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业不上线-委托代开
    '2-0-6': {
      tips: '平台服务费金额 = 终端结算金额 *（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业上线-园区个体
    '2-1-5': {
      tips: '平台服务费金额 = 终端结算金额 *平台服务费率',
      cols: [
        payTargetCol,
        projectSettlementScalePriceCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 平台服务费-工业不上线-园区个体
    '2-0-5': {
      tips: '平台服务费金额 = 终端结算金额 *平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    /*****************************商务服务费******************************** */
    // 商务服务费-工业上线-汇总申报
    '3-1-1': {
      tips: '商务服务费金额 = 项目结算金额【含税】 * （1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业上线-委托代发
    '3-1-3': {
      tips: '平台服务费金额  =  项目结算金额【含税】 * （1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业不上线-汇总申报
    '3-0-1': {
      tips: '商务服务费金额 = 终端结算金额 * （1+供应商服务费率）*（1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        gysSumScaleCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业不上线-委托代发
    '3-0-3': {
      tips: '商务服务费金额 = 终端结算金额 * （1+供应商服务费率）*（1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        gysSumScaleCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业上线-运营基地
    '3-1-4': {
      tips: '商务服务费金额 = 项目结算金额【含税】 * （1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业不上线-运营基地
    '3-0-4': {
      tips: '商务服务费金额 = 终端结算金额 *（1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业上线-委托代开
    '3-1-6': {
      tips: '商务服务费金额 = 终端结算金额 *（1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业不上线-委托代开
    '3-0-6': {
      tips: '商务服务费金额 = 终端结算金额 *（1+增值税率） * 商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业上线-园区个体
    '3-1-5': {
      tips: '商务服务费金额 = 终端结算金额 *商务服务费率',
      cols: [
        payTargetCol,
        projectSettlementScalePriceCol,
        vatRateCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 商务服务费-工业不上线-园区个体
    '3-0-5': {
      tips: '商务服务费金额 = 终端结算金额 *商务服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        commissionCol(2),
        platformServicesPriceCol(2),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 技术服务费-工业上线-运营基地
    '4-1-4': {
      tips: '平台服务费金额 = 项目结算金额【含税】 * （1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        getTaxType().taxType === 1 && projectSettlementScalePriceCol,
        getTaxType().taxType === 2 && csoPriceSumCol,
        vatRateCol,
        useTableColumn({
          label: '技术服务费率（%）',
          prop: 'feeTaxRate',
          formatter: ({ cellValue }) => fen2yuan(+cellValue)
        }),
        useTableColumn({
          label: '技术服务费金额（元）',
          prop: 'serviceFeeAmount',
          formatter: ({ cellValue }) => fen2yuan(+cellValue)
        }),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    },
    // 技术服务费-工业不上线-运营基地
    '4-0-4': {
      tips: '平台服务费金额 = 终端结算金额 *（1+增值税率） * 平台服务费率',
      cols: [
        payTargetCol,
        csoPriceSumCol,
        vatRateCol,
        commissionCol(1),
        platformServicesPriceCol(1),
        {
          ...payStatusCol,
          formatter({ cellValue }) {
            return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
          }
        }
      ]
    }
  };

  return columnsMap[entry];
};
